import { FC, ChangeEvent } from 'react';
import Switch from 'components/shared/generic/switch/presentational/Switch';
import Error from 'components/shared/generic/errorMessage/presentational/Error';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import useTranslate from 'lib/languages/useTranslate';

interface CommunicationPreferencesProps {
    email: boolean;
    push: boolean;
    sms: boolean;
    onPreferenceClick: (name: string, value: boolean) => void;
    postError?: any;
}

const CommunicationPreferences: FC<CommunicationPreferencesProps> = ({
    email,
    push,
    sms,
    onPreferenceClick,
    postError,
}) => {
    const translate = useTranslate('commsPreferences');

    const handleSwitchChange = (e: ChangeEvent<HTMLInputElement>) => {
        onPreferenceClick(e.target.name, e.target.checked);
    };

    return (
        <div className="switch-list-container">
            <div className="switch">
                <SectionTitle
                    title={translate('emailNotifications')}
                    secondary
                />
                <Switch
                    name="emailNotification"
                    value={email}
                    onChange={handleSwitchChange}
                    tracking
                    trackingLabel="RECEIVE_EMAILS_SWITCH_CLICK"
                />
            </div>
            <div className="switch">
                <SectionTitle
                    title={translate('pushNotifications')}
                    secondary
                />
                <Switch
                    name="pushNotification"
                    value={push}
                    onChange={handleSwitchChange}
                    tracking
                    trackingLabel="RECEIVE_PUSH_NOTIFICATIONS_SWITCH_CLICK"
                />
            </div>
            <div className="switch">
                <SectionTitle title={translate('smsNotifications')} secondary />

                <Switch
                    name="smsNotification"
                    value={sms}
                    onChange={handleSwitchChange}
                    tracking
                    trackingLabel="RECEIVE_SMS_SWITCH_CLICK"
                />
            </div>
            {!!postError && <Error message={translate('errorMessage')} />}
        </div>
    );
};

export default CommunicationPreferences;
